<template>
    <div class='footer'>
        <div class='container'>
            <section class="cl-display--flex cl-flex--wrap">
                <div class="footer-content">
                    <!-- <h1>联络我们</h1>
                    <div class="cl-pd_y--10" style="color: #555555;">
                        <div>
                            公司名稱：xxx有限公司
                        </div>
                        <div>
                            統一編號：89583915
                        </div>
                        <div>
                            客服專線：02-2900-7438
                        </div>
                        <div>
                            客服時間：9:00am - 6:00pm
                        </div>
                        <div>
                            信 箱：aibo@aibo.com.tw
                        </div>
                    </div> -->
                    <h1>聯絡資訊</h1>
                    <div class="cl-pd_y--10" style="margin-bottom: 24px;">
                        <span style="display: block;" v-for="item in website.company_info"
                            v-if="item.key !== 'FB_Link' && item.key !== 'Line_Link'">
                            <span>{{ item.key }}</span>：
                            <span v-html="item.value"></span>
                        </span>
                    </div>
                    <h1>關於我們</h1>
                    <ul class="cl-ul">
                        <li><a href="/page/品牌故事">品牌故事</a></li>
                        <li><a href="/page/隱私政策">隱私政策</a></li>
                        <li><a href="/page/防詐騙公告">防詐騙公告</a></li>
                    </ul>
                    <h1>顧客服務</h1>
                    <ul class="cl-ul">
                        <li><a href="/page/付款方式">付款方式</a></li>
                        <li><a href="/page/退換貨需知">退換貨需知</a></li>
                        <li><a href="/page/常見問題">常見問題</a></li>
                        <li><a href="/contact">聯絡我們</a></li>
                        <li><a href="/page/消費者權益">消費者權益</a></li>
                        <li><a href="/page/會員服務條款">會員服務條款</a></li>
                        <!-- <li><a href="javascript:;">連絡我們</a></li> -->
                    </ul>
                </div>
                <div class="icon-svg">
                    <div v-html="getfacebook"></div>
                    <ul class="cl-ul">
                        <li class="qk-display--il_bk">
                            <span v-for="item in website.company_info">
                                <a href="javascript:;" v-if="item.key == 'FB_Link'" :href="item.value">
                                    <svg class="facebook-svg" xmlns="http://www.w3.org/2000/svg" width="30" height="30"
                                        viewBox="0 0 50.5 50.5">
                                        <path class="svg-background"
                                            d="M50.5,32.662c0,9.855-7.983,17.838-17.838,17.838H17.838C7.982,50.5,0,42.517,0,32.662V17.838C0,7.982,7.982,0,17.838,0h14.824C42.517,0,50.5,7.982,50.5,17.838V32.662z M50.5,32.662">
                                        </path>
                                        <path class="svg-border qk-svg--footer_text"
                                            d="M32.516,50.5H17.984C8.068,50.5,0,42.432,0,32.515v-14.53C0,8.068,8.068,0,17.984,0h14.531C42.433,0,50.5,8.068,50.5,17.985v14.53C50.5,42.432,42.433,50.5,32.516,50.5z M17.984,1C8.619,1,1,8.619,1,17.985v14.53C1,41.881,8.619,49.5,17.984,49.5h14.531c9.365,0,16.984-7.619,16.984-16.985v-14.53C49.5,8.619,41.881,1,32.516,1H17.984z">
                                        </path>
                                        <path class="svg-text qk-svg--footer_text"
                                            d="M26.474,19.68v-2.311c0-1.126,0.751-1.388,1.278-1.388c0.526,0,3.242,0,3.242,0v-4.953l-4.465-0.019c-4.957,0-6.083,3.694-6.083,6.059v2.613H17.58v3.492v2.288h2.891c0,6.551,0,14.452,0,14.452h5.78c0,0,0-7.98,0-14.452h4.29l0.208-2.27l0.319-3.51H26.474z">
                                        </path>
                                    </svg>
                                </a>
                            </span>
                        </li>
                        <li class="qk-display--il_bk">
                            <span v-for="item in website.company_info">
                                <a href="javascript:;" v-if="item.key == 'Line_Link'" :href="item.value">
                                    <svg class="line-svg" xmlns="http://www.w3.org/2000/svg" width="30" height="30"
                                        viewBox="0 0 50.5 50.5">
                                        <path class="svg-background"
                                            d="M50.5,32.662c0,9.855-7.983,17.838-17.838,17.838H17.838C7.982,50.5,0,42.517,0,32.662V17.838C0,7.982,7.982,0,17.838,0h14.824C42.517,0,50.5,7.982,50.5,17.838V32.662z M50.5,32.662">
                                        </path>
                                        <path class="svg-border qk-svg--footer_text"
                                            d="M32.516,50.5H17.985C8.068,50.5,0,42.433,0,32.516V17.985C0,8.068,8.068,0,17.985,0h14.531C42.433,0,50.5,8.068,50.5,17.985v14.531C50.5,42.433,42.433,50.5,32.516,50.5z M17.985,1C8.619,1,1,8.619,1,17.985v14.531C1,41.881,8.619,49.5,17.985,49.5h14.531c9.365,0,16.984-7.619,16.984-16.984V17.985C49.5,8.619,41.881,1,32.516,1H17.985z">
                                        </path>
                                        <path class="svg-text qk-svg--footer_text"
                                            d="M39.905,24.124c0-6.557-6.573-11.892-14.654-11.892c-8.08,0-14.655,5.335-14.655,11.892c0,5.878,5.214,10.803,12.256,11.734c0.477,0.102,1.126,0.316,1.291,0.723c0.148,0.37,0.097,0.949,0.047,1.324c0,0-0.172,1.035-0.209,1.256c-0.064,0.37-0.295,1.448,1.269,0.789c1.564-0.659,8.439-4.97,11.513-8.509h-0.001C38.888,29.113,39.905,26.749,39.905,24.124z M19.514,28.025h-2.912c-0.423,0-0.768-0.344-0.768-0.769v-5.823c0-0.423,0.345-0.769,0.768-0.769c0.424,0,0.768,0.346,0.768,0.769v5.055h2.144c0.424,0,0.768,0.345,0.768,0.768C20.282,27.681,19.938,28.025,19.514,28.025z M22.525,27.256c0,0.425-0.344,0.769-0.768,0.769s-0.768-0.344-0.768-0.769v-5.823c0-0.423,0.344-0.769,0.768-0.769s0.768,0.346,0.768,0.769V27.256z M29.535,27.256c0,0.332-0.211,0.625-0.526,0.73c-0.079,0.026-0.162,0.039-0.244,0.039c-0.24,0-0.469-0.114-0.614-0.308l-2.985-4.063v3.602c0,0.425-0.344,0.769-0.768,0.769c-0.424,0-0.769-0.344-0.769-0.769v-5.823c0-0.331,0.212-0.623,0.526-0.729c0.079-0.026,0.161-0.04,0.244-0.04c0.24,0,0.47,0.115,0.614,0.308l2.985,4.064v-3.604c0-0.423,0.345-0.769,0.769-0.769c0.424,0,0.768,0.346,0.768,0.769V27.256zM34.246,23.577c0.424,0,0.768,0.344,0.768,0.769c0,0.423-0.344,0.768-0.768,0.768h-2.143v1.374h2.143c0.423,0,0.768,0.345,0.768,0.768c0,0.425-0.346,0.769-0.768,0.769h-2.912c-0.423,0-0.768-0.344-0.768-0.769v-2.909c0,0,0-0.001,0-0.002v-2.912c0-0.423,0.345-0.769,0.768-0.769h2.912c0.424,0,0.768,0.346,0.768,0.769c0,0.424-0.344,0.769-0.768,0.769h-2.143v1.375H34.246z">
                                        </path>
                                    </svg>
                                </a>
                            </span>
                        </li>
                        <!-- <li class="qk-display--il_bk">
                            <a href="javascript:;">
                                <svg class="youtube-svg" xmlns="http://www.w3.org/2000/svg" width="30" height="30"
                                    viewBox="0 0 50.5 50.5">
                                    <path class="svg-background"
                                        d="M50.5,32.662c0,9.855-7.983,17.838-17.838,17.838H17.838C7.982,50.5,0,42.517,0,32.662V17.838C0,7.982,7.982,0,17.838,0h14.824C42.517,0,50.5,7.982,50.5,17.838V32.662z M50.5,32.662">
                                    </path>
                                    <path class="svg-border qk-svg--footer_text"
                                        d="M32.516,50.5H17.984C8.068,50.5,0,42.432,0,32.515v-14.53C0,8.068,8.068,0,17.984,0h14.531C42.433,0,50.5,8.068,50.5,17.985v14.53C50.5,42.432,42.433,50.5,32.516,50.5z M17.984,1C8.619,1,1,8.619,1,17.985v14.53C1,41.881,8.619,49.5,17.984,49.5h14.531c9.365,0,16.984-7.619,16.984-16.985v-14.53C49.5,8.619,41.881,1,32.516,1H17.984z">
                                    </path>
                                    <path class="svg-text qk-svg--footer_text"
                                        d="M39.411,19.224c0,0-0.282-2.078-1.147-2.992c-1.1-1.199-2.331-1.206-2.894-1.276c-4.047-0.303-10.113-0.303-10.113-0.303h-0.013c0,0-6.069,0-10.112,0.305c-0.565,0.068-1.795,0.076-2.897,1.275c-0.865,0.914-1.147,2.993-1.147,2.993s-0.29,2.438-0.29,4.877v0.294v1.991c0,2.441,0.29,4.879,0.29,4.879s0.282,2.077,1.147,2.991c1.101,1.201,2.547,1.162,3.188,1.287c2.313,0.231,9.826,0.304,9.826,0.304s6.072-0.011,10.12-0.314c0.563-0.071,1.795-0.076,2.894-1.277c0.866-0.914,1.147-2.991,1.147-2.991s0.291-2.438,0.291-4.879v-1.864v-0.421C39.701,21.662,39.411,19.224,39.411,19.224z M30.073,24.942l-7.806,4.218l-0.002-6.493l0-1.974l3.521,1.916L30.073,24.942z">
                                    </path>
                                </svg>
                            </a>
                        </li> -->
                    </ul>
                </div>
            </section>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
    components: {},
    data() {
        return {
        };
    },
    computed: {
        ...mapState('header', ['website','getfacebook']),
    },
    watch: {},
    methods: {
    },
    created() {
    },
    mounted() {
    },
}
</script>
<style src="./index.scss" lang="scss" scoped></style>
<style lang='scss' scoped>
.footer {
    font-size: 14px;
    padding: 0 0 20px;

    .footer-content {
        margin-right: auto;
        max-width: 735px;

        // width: 500px;
        // flex: 1;
        h1 {
            font-size: 15px;
            margin: 0 0 8px;
        }
        ul{
            display: flex;
            margin-bottom: 24px;
            li{
                margin-right: 20px;
                a{
                    text-decoration: none;
                    list-style: none;
                    color: #555555;
                }
            }
        }
    }

    .icon-svg {
        ul {
            display: inline-block;
            display: flex;

            li {
                margin: 0 5px;

                a {
                    svg {

                        .svg-background {
                            fill: transparent;
                        }

                        .svg-text {
                            fill: #555555;
                        }

                        &:hover {


                            .svg-text {
                                fill: #fff;
                            }
                        }
                    }

                    .line-svg {
                        &:hover {
                            .svg-background {
                                fill: green;
                            }

                        }
                    }

                    .facebook-svg {
                        &:hover {
                            .svg-background {
                                fill: #3a59a4;
                            }

                        }
                    }

                }
            }
        }
    }
}


@media (max-width:991px) {
    .footer {
        padding-bottom: 48px;

        section {
            justify-content: center;
        }

        .icon-svg {
            ul {
                padding: 16px 0;
                // width: 100vw;
            }
        }
    }

}
</style>